// Per-journey accent hex + pill colors, rotated by index via COLOR_ORDER.
export type JourneyAccent = {
  hex: string;
  pillBg: string;
  pillText: string;
  tint: string;
};

export const JOURNEY_PALETTE: Record<string, JourneyAccent> = {
  purple: {
    hex: '#7c6cf6',
    pillBg: '#f0eefe',
    pillText: '#5B4BD6',
    tint: 'rgba(124, 108, 246, 0.12)',
  },
  green: {
    hex: '#10b981',
    pillBg: '#ecfdf5',
    pillText: '#059669',
    tint: 'rgba(16, 185, 129, 0.12)',
  },
  amber: {
    hex: '#f59e0b',
    pillBg: '#fffbeb',
    pillText: '#B45309',
    tint: 'rgba(245, 158, 11, 0.14)',
  },
  blue: {
    hex: '#5c6fff',
    pillBg: '#eef1ff',
    pillText: '#4558E0',
    tint: 'rgba(92, 111, 255, 0.12)',
  },
  teal: {
    hex: '#14b8a6',
    pillBg: '#f0fdfa',
    pillText: '#0F766E',
    tint: 'rgba(20, 184, 166, 0.12)',
  },
  pink: {
    hex: '#ec4899',
    pillBg: '#fdf2f8',
    pillText: '#BE185D',
    tint: 'rgba(236, 72, 153, 0.12)',
  },
};

export const COLOR_ORDER: (keyof typeof JOURNEY_PALETTE)[] = ['purple', 'green', 'amber', 'blue', 'teal', 'pink'];

export const accentForIndex = (index: number): JourneyAccent =>
  JOURNEY_PALETTE[COLOR_ORDER[index % COLOR_ORDER.length]];
